import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from '../Components/Items';

moment.locale("es");

const reporteDeCuentasPorCobrarTotales = (values) => {
    const empresa = values.empresa;
    const logoBiwo = values.logoBiwo;

    // Agrupar ventas por cliente (solo filas principales)
    const totalesPorCliente = {};
    for (const venta of values.ventas) {
        const esPrincipal = venta.folio && typeof venta.fechaFactura === 'string' &&
            moment(venta.fechaFactura, "DD/MM/YYYY", true).isValid();
        if (!esPrincipal) continue;

        const cliente = venta.cliente || 'Sin cliente';
        if (!totalesPorCliente[cliente]) {
            totalesPorCliente[cliente] = { total: 0, vencido: 0, noVencido: 0 };
        }
        const saldo = venta.saldo || 0;
        totalesPorCliente[cliente].total += saldo;
        if (typeof venta.fechaVencimiento === 'string' && moment(venta.fechaVencimiento, "DD/MM/YYYY", true).isValid()) {
            if (moment(venta.fechaVencimiento, "DD/MM/YYYY").isBefore(moment())) {
                totalesPorCliente[cliente].vencido += saldo;
            } else {
                totalesPorCliente[cliente].noVencido += saldo;
            }
        } else {
            totalesPorCliente[cliente].noVencido += saldo;
        }
    }

    let granTotal = 0;
    let granTotalVencido = 0;
    let granTotalNoVencido = 0;

    const filas = Object.entries(totalesPorCliente)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([cliente, totales]) => {
            granTotal += totales.total;
            granTotalVencido += totales.vencido;
            granTotalNoVencido += totales.noVencido;
            return [
                { text: cliente, style: 'textoTabla', alignment: 'left' },
                { text: dineroDisabledMask(totales.total), style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(totales.vencido), style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(totales.noVencido), style: 'textoTabla', alignment: 'right' },
            ];
        });

    filas.push([
        { text: 'GRAN TOTAL:', style: 'totalesTabla', alignment: 'left', fillColor: '#aaaaaa' },
        { text: dineroDisabledMask(granTotal), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
        { text: dineroDisabledMask(granTotalVencido), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
        { text: dineroDisabledMask(granTotalNoVencido), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
    ]);

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: ['18%', '52%', '30%'],
                    layout: { defaultBorder: false },
                    body: [
                        [
                            {
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80]
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],
                                    body: [
                                        [{ text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre + ' ' + empresa.apellidoPaterno + ' ' + empresa.apellidoMaterno), style: 'tableHeader' }],
                                        [{ text: 'R.F.C: ' + empresa.rfc, style: 'textoChico', alignment: 'center' }],
                                        [{ text: empresa.calle + ' ' + empresa.numeroCalle + ' ' + (empresa.numeroInterior ? empresa.numeroInterior : ''), style: 'textoChico', alignment: 'center' }],
                                        [{ text: empresa.colonia.tipoAsentamiento + ' ' + empresa.colonia.nombre + ' C.P. ' + empresa.colonia.cp + ' ' + empresa.municipio.nombre + ' ' + empresa.estado.abreviatura + ' ' + empresa.pais.abreviatura, style: 'textoChico', alignment: 'center' }],
                                        [{ text: 'REPORTE DE CUENTAS POR COBRAR - TOTALES POR CLIENTE', style: 'tableHeader' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],
                                    body: [
                                        [{ text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center' }],
                                        [{ text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                        ]
                    ]
                },
            },
            {
                style: 'tableExample',
                table: {
                    widths: ['40%', '20%', '20%', '20%'],
                    headerRows: 1,
                    body: [
                        [
                            { text: 'Cliente', style: 'tituloTabla' },
                            { text: 'Total', style: 'tituloTabla' },
                            { text: 'Total Vencido', style: 'tituloTabla' },
                            { text: 'Total No Vencido', style: 'tituloTabla' },
                        ],
                        ...filas,
                    ]
                },
                layout: {
                    fillColor: (rowIndex) => rowIndex % 2 === 0 ? '#e8e8e8' : '#ffffff',
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#adaaaa',
                    vLineColor: () => '#adaaaa',
                    hLineStyle: (i, node) => (i === 0 || i === node.table.body.length) ? null : { dash: { length: 2, space: 1 } },
                    vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length) ? null : { dash: { length: 2 } },
                }
            },
        ],
        images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
        },
        styles: {
            tableHeader: { bold: true, fontSize: 12, color: 'black', alignment: 'center' },
            subheader: { fontSize: 8, bold: true },
            tableExample: { margin: [0, 5, 0, 5] },
            textoChico: { fontSize: 8 },
            tituloTabla: { fontSize: 8, bold: true, fillColor: '#cccccc', alignment: 'center', border: true },
            textoTabla: { fontSize: 8, italics: false },
            totalesTabla: { fontSize: 8, bold: true, italics: false },
        },
        pageSize: 'LETTER',
        pageMargins: [20, 20, 20, 60],
    };

    return dd;
};

export default reporteDeCuentasPorCobrarTotales;
